const LEADS_SAVE_RESULT = {
  MISSING_FIELDS: "missing_fields",
  LEAD_STATUS_UPDATE: "lead_status_update",
  PENDING_COMMITMENTS: "pending_commitments"
} as const

type LeadsSaveResultType =
  (typeof LEADS_SAVE_RESULT)[keyof typeof LEADS_SAVE_RESULT]

export { LEADS_SAVE_RESULT }
export type { LeadsSaveResultType }
